// JOBE-0158.5: Storyboard — 4–5-step horizontal flow visualization.
//
// Used for:
//   1. In-app journey documentation (e.g. Admin help pages rendering J1–J5).
//   2. W6 cohort-fix preview (bundle → eval → ship → audit).
//
// API shape:
//   <Storyboard
//     steps={[
//       { surface: 'W1', body: 'Operator opens Jobe…', doNext: '→ W4 Finance' },
//       ...
//       { surface: 'W1', body: 'Audit event emitted.', doNext: null },
//     ]}
//     ariaLabel="J1 Morning triage journey"
//   />
//
// Validation warnings (renders regardless):
//   - steps.length < 3 or > 6
//   - any step missing surface or body

import './Storyboard.css';

function stepBackground(index, total) {
  if (index === 0) return 'var(--signal)';
  if (index === total - 1) return 'var(--paper-2)';
  return 'var(--paper)';
}

export function Storyboard({ steps, ariaLabel }) {
  if (!Array.isArray(steps) || steps.length < 3 || steps.length > 6) {
    // eslint-disable-next-line no-console
    console.warn(
      `[Storyboard] steps.length=${steps?.length ?? 0} is outside the expected 3–6 range. ` +
      'Rendering as supplied.',
    );
  }

  const safeSteps = Array.isArray(steps) ? steps : [];

  safeSteps.forEach((step, i) => {
    if (!step.surface) {
      // eslint-disable-next-line no-console
      console.warn(`[Storyboard] step[${i}] is missing required field "surface".`);
    }
    if (!step.body) {
      // eslint-disable-next-line no-console
      console.warn(`[Storyboard] step[${i}] is missing required field "body".`);
    }
  });

  const total = safeSteps.length;

  return (
    <ol className="storyboard" role="list" aria-label={ariaLabel}>
      {safeSteps.map((step, i) => {
        const showConnector = i < total - 1 && step.doNext !== null;
        return (
          <li key={i} className="storyboard__item">
            <div
              className="storyboard__card"
              style={{ background: stepBackground(i, total) }}
            >
              <span className="storyboard__surface">
                {step.surface ?? ''}
              </span>
              <span className="storyboard__body">
                {step.body ?? ''}
              </span>
              {step.doNext != null && (
                <span className="storyboard__do-next">
                  {step.doNext}
                </span>
              )}
            </div>
            {showConnector && (
              <span
                className="storyboard__connector"
                aria-hidden="true"
              >
                →
              </span>
            )}
          </li>
        );
      })}
    </ol>
  );
}
